import { FunctionComponent, useEffect } from "react";
import { Box, Link, Typography } from '@material-ui/core'
import { useEmailConfirmation } from "../hooks/useEmailConfirmation";
//@ts-ignore
import { useTheme } from 'styled-components'
import { BackendUser } from "common/types";

interface ShowTimerTextProps {
  user: BackendUser
  timer: number
  setTimer: Function
  setErrorCount: Function
  setErrorMessage: Function
}


export const ShowTimerText: FunctionComponent<ShowTimerTextProps> = ({ user, timer, setTimer, setErrorCount, setErrorMessage }) => {
  const theme = useTheme()
  const { resendConfirmationCode, countdown, clearItem } = useEmailConfirmation()

  useEffect(() => {
    let interval = setInterval(() => {
      setTimer(prevTimer => prevTimer - 1000)
    }, 1000)
    if (timer === 0) {
      return clearInterval(interval)
    }
    return () => clearInterval(interval)
  }, [timer])
  
  const showTime = () => {
    if (timer === 0) {
      return (
        <Box>
          <Typography>
            <Box color={theme.colors.error} mt="1em">
              Code expired. Click on
              <Link
                style={{
                  display: 'inline-block',
                  marginLeft: '0.5em'
                }}
                onClick={() => {
                  resendConfirmationCode(user?.id)
                  setTimer(90000)
                  setErrorCount(0)
                  setErrorMessage('')
                  clearItem('browserClosed')
                }}
              >
                Resend Code
              </Link>
            </Box>
          </Typography>
        </Box>
      )
    } else if (timer <= 30000) {
      return (
        <Typography>
          <Box color={theme.colors.error}>{countdown(timer)}</Box>
        </Typography>
      )
    } else {
      return (
        <Typography>
          <Box color={theme.colors.accent1}>{countdown(timer)}</Box>
        </Typography>
      )
    }
  }

  return (
    <Box>
      {showTime()}
    </Box>
  )
}